import { useEffect, useState } from "react";
import useAxiosInstance from "../../../../../Utilities/Hooks/useAxiosInstance";
import Form from "../../../../Partials/Layouts/Forms/Form";
import ShortTextInput from "../../../../Partials/Layouts/Forms/FormInputs/ShortTextInput/ShortTextInput";
import FormSubmitButton from "../../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton";
import SwitchInput from "../../../../Partials/Layouts/Forms/FormInputs/SwitchInput/SwitchInput";
import { BLOGS_API } from "../../../../../Utilities/APIs/APIs";
import ImageInput from "../../../../Partials/Layouts/Forms/FormInputs/ImageInput/ImageInput";
import CustomEditor from "../../../../Partials/Elements/CustomEditor/CustomEditor";

function UpdateBlog({ targetID, triggerFetch, setShowUpdateForm }) {
  const axiosInstance = useAxiosInstance();

  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [excerpt, setExcerpt] = useState("");
  const [sectionOneTitle, setSectionOneTitle] = useState("");
  const [sectionOneText, setSectionOneText] = useState("");
  const [sectionTwoTitle, setSectionTwoTitle] = useState("");
  const [sectionTwoText, setSectionTwoText] = useState("");
  const [precedence, setPrecedence] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  const [image, setImage] = useState("");
  const [secondImage, setSecondImage] = useState("");

  useEffect(() => {
    async function fetchAndSetSingleBlog() {
      const { data } = await axiosInstance.get(BLOGS_API + targetID);

      setTitle(data.title || "");
      setCategory(data.category || "");
      setExcerpt(data.excerpt || "");
      setSectionOneTitle(data.sectionOneTitle || "");
      setSectionOneText(data.sectionOneText || "");
      setSectionTwoTitle(data.sectionTwoTitle || "");
      setSectionTwoText(data.sectionTwoText || "");
      setPrecedence(data.precedence || 0);
      setIsVisible(data.isVisible ?? true);

      setImage(data.image || "");
      setSecondImage(data.secondImage || "");
    }

    fetchAndSetSingleBlog();
  }, [targetID, axiosInstance]);

  async function handleSubmit(e) {
    e.preventDefault();

    const itemData = new FormData();

    itemData.append("title", title);
    itemData.append("category", category);
    itemData.append("excerpt", excerpt);
    itemData.append("sectionOneTitle", sectionOneTitle);
    itemData.append("sectionOneText", sectionOneText);
    itemData.append("sectionTwoTitle", sectionTwoTitle);
    itemData.append("sectionTwoText", sectionTwoText);
    itemData.append("precedence", precedence);
    itemData.append("isVisible", isVisible);

    if (image instanceof File) {
      itemData.append("image", image);
    }

    if (secondImage instanceof File) {
      itemData.append("secondImage", secondImage);
    }

    const response = await axiosInstance.patch(BLOGS_API + targetID, itemData);

    if (response) {
      triggerFetch();
      setShowUpdateForm(false);
    }
  }

  return (
    <div className="crate_form">
      <Form onSubmit={handleSubmit}>
        <div>
          <ShortTextInput label="Title" value={title} placeholder="Enter Title" setState={setTitle} />

          <ShortTextInput label="Category" value={category} placeholder="Enter Category" setState={setCategory} />

          <ShortTextInput label="Quotation" value={excerpt} placeholder="Enter Quotation" setState={setExcerpt} />

          <ShortTextInput label="Section One Title" value={sectionOneTitle} placeholder="Enter Section One Title" setState={setSectionOneTitle} />

          <label style={{ display: "block", fontWeight: 600, fontSize: "1.6rem", lineHeight: "2rem", color: "#E6E6E6", textTransform: "capitalize", marginBottom: "1.4rem" }}>
            Section One Text
          </label>

          <CustomEditor data={sectionOneText} setState={setSectionOneText} placeholder="Section One Text…" />

          <ShortTextInput label="Section Two Title" value={sectionTwoTitle} placeholder="Enter Section Two Title" setState={setSectionTwoTitle} />

          <label style={{ display: "block", fontWeight: 600, fontSize: "1.6rem", lineHeight: "2rem", color: "#E6E6E6", textTransform: "capitalize", marginBottom: "1.4rem" }}>
            Section Two Text
          </label>

          <CustomEditor data={sectionTwoText} setState={setSectionTwoText} placeholder="Section Two Text…" />

          <ShortTextInput label="Precedence" value={precedence} placeholder="Enter Precedence" setState={setPrecedence} />

          <ImageInput fieldId="1" state={image} setState={setImage} allowUpdateImage>
            Upload Main Image
          </ImageInput>

          <ImageInput fieldId="2" state={secondImage} setState={setSecondImage} allowUpdateImage>
            Upload Second Image
          </ImageInput>

          <SwitchInput
            label="Visible"
            toggleSwitch={() => setIsVisible((prevState) => !prevState)}
            checked={isVisible}
          />
        </div>

        <FormSubmitButton text="Submit" />
      </Form>
    </div>
  );
}

export default UpdateBlog;